(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["edenpure-family-parts"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initFamilyFinder() {

    const section = document.querySelector('.ep-family-parts');

    if (!section || section.dataset.finderReady === 'true') {
      return;
    }

    section.dataset.finderReady = 'true';

    const form = section.querySelector('#ep-family-search-form');
    const input = section.querySelector('#ep-family-search-input');
    const message = section.querySelector('#ep-family-search-message');

    if (!form || !input || !message) {
      return;
    }

    const records = Array.from(
      section.querySelectorAll('.ep-family-record')
    ).map(function(record) {

      return {
        name: record.dataset.name || '',
        primary: record.dataset.primary || '',
        alternates: (record.dataset.alternates || '')
          .split('|||')
          .filter(Boolean),
        aliases: (record.dataset.aliases || '')
          .split('|||')
          .filter(Boolean),
        url: record.dataset.url || ''
      };

    });


    function normalize(value) {

      return String(value || '')
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '');

    }


    function searchableValues(record) {

      return [
        record.name,
        record.primary,
        ...record.alternates,
        ...record.aliases
      ]
      .map(normalize)
      .filter(Boolean);

    }


    form.addEventListener('submit', function(event) {

      event.preventDefault();

      message.textContent = '';

      const query = normalize(input.value);

      if (!query) {

        message.textContent =
          'Enter a model number or model name.';

        input.focus();
        return;

      }


      const exactMatches = records.filter(function(record) {

        return searchableValues(record).includes(query);

      });


      if (exactMatches.length === 1) {

        window.location.href = exactMatches[0].url;
        return;

      }


      const partialMatches = records.filter(function(record) {

        return searchableValues(record).some(function(value) {
          return value.includes(query);
        });

      });


      if (partialMatches.length === 1) {

        window.location.href = partialMatches[0].url;
        return;

      }


      if (partialMatches.length > 1) {

        message.textContent =
          'More than one model matches. Please enter the complete model number.';

        return;

      }


      message.textContent =
        "We couldn't match that model. Check the model number on your EdenPURE product label.";

    });

  }


  document.addEventListener(
    'DOMContentLoaded',
    initFamilyFinder
  );


  document.addEventListener(
    'shopify:section:load',
    initFamilyFinder
  );


  initFamilyFinder();

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edenpure-guided-model-finder"] && !Shopify.designMode) return;
  try {
    

  function sendEdenPUREGuidedFinderGA4Event(eventName, parameters) {

    if (typeof window.gtag !== 'function') {
      return;
    }

    window.gtag(
      'event',
      eventName,
      parameters || {}
    );

  }


  function sendEdenPUREGuidedFinderGA4EventThenNavigate(
    eventName,
    parameters,
    url
  ) {

    if (typeof window.gtag !== 'function') {
      window.location.href = url;
      return;
    }

    let navigated = false;

    function navigate() {

      if (navigated) {
        return;
      }

      navigated = true;
      window.location.href = url;

    }

    const eventParameters = Object.assign(
      {},
      parameters || {},
      {
        event_callback: navigate,
        event_timeout: 800
      }
    );

    window.gtag(
      'event',
      eventName,
      eventParameters
    );

    window.setTimeout(
      navigate,
      900
    );

  }


  function initializeEdenPUREGuidedModelFinders() {

    document
      .querySelectorAll('[data-ep-guided-model-finder]')
      .forEach(function (finder) {

        if (finder.dataset.initialized === 'true') {
          return;
        }

        finder.dataset.initialized = 'true';

        const buttonContainer =
          finder.querySelector('[data-family-buttons]');

        const selectedFamilyText =
          finder.querySelector('[data-selected-family]');

        const grid =
          finder.querySelector('.ep-guided-finder__grid');

        const cards = Array.from(
          finder.querySelectorAll('[data-model-card]')
        );

        const isHomepage =
          finder.dataset.isHomepage === 'true';

        if (!buttonContainer || !grid || !cards.length) {
          return;
        }


        const familyLabels = {
          'heater': 'Heaters',
          'air purifier': 'Air Purifiers',
          'fan': 'Fans & Cooling',
          'vacuum': 'Vacuums',
          'humidifier': 'Humidifiers',
          'laundry': 'Laundry'
        };


        const familyHeadings = {
          'heater': 'Choose Your EdenPURE® Heater',
          'air purifier': 'Choose Your EdenPURE® Air Purifier',
          'fan': 'Choose Your EdenPURE® Fan',
          'vacuum': 'Choose Your EdenPURE® Vacuum',
          'humidifier': 'Choose Your EdenPURE® Humidifier',
          'laundry': 'Choose Your EdenPURE® Laundry System'
        };


        const preferredOrder = [
          'heater',
          'air purifier',
          'fan',
          'vacuum',
          'humidifier',
          'laundry'
        ];


        const availableFamilies = Array.from(
          new Set(
            cards
              .map(function (card) {
                return (card.dataset.family || '').trim().toLowerCase();
              })
              .filter(Boolean)
          )
        );


        const orderedFamilies = [];

        preferredOrder.forEach(function (family) {
          if (availableFamilies.includes(family)) {
            orderedFamilies.push(family);
          }
        });


        availableFamilies
          .filter(function (family) {
            return !orderedFamilies.includes(family);
          })
          .sort()
          .forEach(function (family) {
            orderedFamilies.push(family);
          });


        function labelForFamily(family) {

          if (familyLabels[family]) {
            return familyLabels[family];
          }

          return family
            .split(' ')
            .map(function (word) {
              return word.charAt(0).toUpperCase() + word.slice(1);
            })
            .join(' ');

        }


        function headingForFamily(family) {

          if (familyHeadings[family]) {
            return familyHeadings[family];
          }

          return 'Choose Your EdenPURE® ' + labelForFamily(family);

        }


        function getSortOrder(card) {

          const rawValue =
            (card.dataset.sortOrder || '').trim();

          if (!rawValue) {
            return Number.MAX_SAFE_INTEGER;
          }

          const numericValue = Number(rawValue);

          if (Number.isNaN(numericValue)) {
            return Number.MAX_SAFE_INTEGER;
          }

          return numericValue;

        }


        function compareCards(a, b) {

          const orderA = getSortOrder(a);
          const orderB = getSortOrder(b);

          if (orderA !== orderB) {
            return orderA - orderB;
          }

          const nameA =
            (a.dataset.modelName || '').trim();

          const nameB =
            (b.dataset.modelName || '').trim();

          return nameA.localeCompare(
            nameB,
            undefined,
            {
              numeric: true,
              sensitivity: 'base'
            }
          );

        }


        function lifecycleGroup(card) {

          const status =
            (card.dataset.status || '')
              .trim()
              .toLowerCase()
              .replace(/\s+/g, '');

          if (
            status === 'current' ||
            status === 'current/past' ||
            status === 'current&past'
          ) {
            return 'current';
          }

          if (status === 'past') {
            return 'past';
          }

          return 'additional';

        }


        function removeLifecycleHeadings() {

          finder
            .querySelectorAll('[data-lifecycle-heading]')
            .forEach(function (heading) {
              heading.remove();
            });

        }


        function appendLifecycleHeading(label) {

          const heading =
            document.createElement('div');

          heading.className =
            'ep-guided-finder__lifecycle-heading';

          heading.dataset.lifecycleHeading = 'true';
          heading.textContent = label;

          grid.appendChild(heading);

        }


        function selectFamily(family) {

          removeLifecycleHeadings();

          cards.forEach(function (card) {
            card.hidden = true;
          });

          const familyCards = cards
            .filter(function (card) {

              const cardFamily =
                (card.dataset.family || '')
                  .trim()
                  .toLowerCase();

              return cardFamily === family;

            })
            .sort(compareCards);


          if (isHomepage) {

            familyCards.forEach(function (card) {
              grid.appendChild(card);
              card.hidden = false;
            });

          } else {

            const currentCards =
              familyCards.filter(function (card) {
                return lifecycleGroup(card) === 'current';
              });

            const pastCards =
              familyCards.filter(function (card) {
                return lifecycleGroup(card) === 'past';
              });

            const additionalCards =
              familyCards.filter(function (card) {
                return lifecycleGroup(card) === 'additional';
              });


            if (currentCards.length) {

              appendLifecycleHeading('Current Models');

              currentCards.forEach(function (card) {
                grid.appendChild(card);
                card.hidden = false;
              });

            }


            if (pastCards.length) {

              appendLifecycleHeading('Past Models');

              pastCards.forEach(function (card) {
                grid.appendChild(card);
                card.hidden = false;
              });

            }


            if (additionalCards.length) {

              appendLifecycleHeading('Additional Models');

              additionalCards.forEach(function (card) {
                grid.appendChild(card);
                card.hidden = false;
              });

            }

          }


          buttonContainer
            .querySelectorAll('.ep-guided-family-button')
            .forEach(function (button) {

              button.setAttribute(
                'aria-pressed',
                button.dataset.family === family
                  ? 'true'
                  : 'false'
              );

            });


          if (selectedFamilyText) {
            selectedFamilyText.textContent =
              headingForFamily(family);
          }

        }


        orderedFamilies.forEach(function (family) {

          const button =
            document.createElement('button');

          button.type = 'button';
          button.className =
            'ep-guided-family-button';

          button.dataset.family = family;
          button.textContent =
            labelForFamily(family);

          button.setAttribute(
            'aria-pressed',
            'false'
          );

          button.addEventListener(
            'click',
            function () {

              sendEdenPUREGuidedFinderGA4Event(
                'family_selected',
                {
                  product_family: family,
                  family_label: labelForFamily(family),
                  finder_location: isHomepage
                    ? 'homepage'
                    : 'model_finder_page',
                  page_path: window.location.pathname
                }
              );

              selectFamily(family);

            }
          );

          buttonContainer.appendChild(button);

        });


        cards.forEach(function (card) {

          card.addEventListener('click', function (event) {

            const destination =
              card.getAttribute('href') || '';

            const eventParameters = {
              model_name:
                (card.dataset.modelName || '').trim(),
              model_number:
                (card.dataset.modelNumber || '').trim(),
              product_family:
                (card.dataset.family || '').trim(),
              model_status:
                (card.dataset.status || '').trim(),
              destination_path: destination,
              finder_location: isHomepage
                ? 'homepage'
                : 'model_finder_page',
              page_path: window.location.pathname
            };

            if (
              event.metaKey ||
              event.ctrlKey ||
              event.shiftKey ||
              event.altKey
            ) {

              sendEdenPUREGuidedFinderGA4Event(
                'model_selected',
                eventParameters
              );

              return;

            }

            event.preventDefault();

            sendEdenPUREGuidedFinderGA4EventThenNavigate(
              'model_selected',
              eventParameters,
              destination
            );

          });

        });


        let defaultFamily =
          (finder.dataset.defaultFamily || '')
            .trim()
            .toLowerCase();


        if (!availableFamilies.includes(defaultFamily)) {

          if (availableFamilies.includes('heater')) {
            defaultFamily = 'heater';
          } else {
            defaultFamily =
              orderedFamilies[0] || '';
          }

        }


        if (defaultFamily) {
          selectFamily(defaultFamily);
        }

      });

  }


  document.addEventListener(
    'DOMContentLoaded',
    initializeEdenPUREGuidedModelFinders
  );


  document.addEventListener(
    'shopify:section:load',
    initializeEdenPUREGuidedModelFinders
  );


  initializeEdenPUREGuidedModelFinders();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edenpure-model-finder"] && !Shopify.designMode) return;
  try {
    

  function initializeEdenPUREModelFinders() {

    function sendGA4Event(eventName, parameters) {

      if (typeof window.gtag !== 'function') {
        return;
      }

      window.gtag(
        'event',
        eventName,
        parameters || {}
      );

    }


    function sendGA4EventThenNavigate(eventName, parameters, url) {

      if (typeof window.gtag !== 'function') {
        window.location.href = url;
        return;
      }

      let navigated = false;

      function navigate() {

        if (navigated) {
          return;
        }

        navigated = true;
        window.location.href = url;

      }

      const eventParameters = Object.assign(
        {},
        parameters || {},
        {
          event_callback: navigate,
          event_timeout: 800
        }
      );

      window.gtag(
        'event',
        eventName,
        eventParameters
      );

      window.setTimeout(
        navigate,
        900
      );

    }


    document.querySelectorAll('[data-ep-model-finder]').forEach(function (finder) {

      if (finder.dataset.initialized === 'true') {
        return;
      }

      finder.dataset.initialized = 'true';

      const form = finder.querySelector('[data-model-finder-form]');
      const input = finder.querySelector('[data-model-finder-input]');
      const message = finder.querySelector('[data-model-finder-message]');
      const helpLink = finder.querySelector('[data-model-finder-help]');

      if (!form || !input || !message) {
        return;
      }


      const records = Array.from(
        finder.querySelectorAll('.ep-model-record')
      ).map(function (record) {

        return {
          name: record.dataset.name || '',
          primary: record.dataset.primary || '',
          alternates: (record.dataset.alternates || '')
            .split('|||')
            .filter(Boolean),
          aliases: (record.dataset.aliases || '')
            .split('|||')
            .filter(Boolean),
          url: record.dataset.url || ''
        };

      });


      function normalize(value) {

        return String(value || '')
          .toUpperCase()
          .replace(/[^A-Z0-9]/g, '');

      }


      function searchableValues(record) {

        return [
          record.name,
          record.primary,
          ...record.alternates,
          ...record.aliases
        ]
          .map(normalize)
          .filter(Boolean);

      }


      function showError(text) {

        message.textContent = text;
        message.classList.add('ep-model-finder__message--error');

      }


      function clearMessage() {

        message.textContent = '';
        message.classList.remove('ep-model-finder__message--error');

      }


      function reportFound(record, matchType) {

        sendGA4EventThenNavigate(
          'model_found',
          {
            match_type: matchType,
            matched_model_name: record.name,
            matched_model_number: record.primary,
            destination_path: record.url
          },
          record.url
        );

      }


      if (helpLink) {

        helpLink.addEventListener('click', function () {

          sendGA4Event(
            'guided_finder_start',
            {
              entry_point: 'model_number_help',
              page_path: window.location.pathname
            }
          );

        });

      }


      form.addEventListener('submit', function (event) {

        event.preventDefault();

        clearMessage();

        const query = normalize(input.value);

        if (!query) {

          showError('Enter a model number or model name.');
          input.focus();
          return;

        }


        sendGA4Event(
          'model_search',
          {
            query_character_count: query.length,
            page_path: window.location.pathname
          }
        );


        const exactMatches = records.filter(function (record) {

          return searchableValues(record).includes(query);

        });


        if (exactMatches.length === 1) {

          reportFound(
            exactMatches[0],
            'exact'
          );

          return;

        }


        if (exactMatches.length > 1) {

          sendGA4Event(
            'model_not_found',
            {
              failure_reason: 'multiple_exact_matches',
              match_count: exactMatches.length,
              page_path: window.location.pathname
            }
          );

          showError(
            'More than one model matches that entry. Please enter the complete model number.'
          );

          return;

        }


        const partialMatches = records.filter(function (record) {

          return searchableValues(record).some(function (value) {
            return value.includes(query);
          });

        });


        if (partialMatches.length === 1) {

          reportFound(
            partialMatches[0],
            'partial'
          );

          return;

        }


        if (partialMatches.length > 1) {

          sendGA4Event(
            'model_not_found',
            {
              failure_reason: 'multiple_partial_matches',
              match_count: partialMatches.length,
              page_path: window.location.pathname
            }
          );

          showError(
            'We found more than one possible model. Please enter the complete model number.'
          );

          return;

        }


        sendGA4Event(
          'model_not_found',
          {
            failure_reason: 'no_match',
            match_count: 0,
            page_path: window.location.pathname
          }
        );

        showError(
          "We couldn't match that model. Check the model number on your EdenPURE product label."
        );

      });

    });

  }


  document.addEventListener(
    'DOMContentLoaded',
    initializeEdenPUREModelFinders
  );


  document.addEventListener(
    'shopify:section:load',
    initializeEdenPUREModelFinders
  );


  initializeEdenPUREModelFinders();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edenpure-part-type"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initializePartTypeFinder() {

    const section =
      document.getElementById('ep-part-type-page');

    if (!section || section.dataset.initialized === 'true') {
      return;
    }

    section.dataset.initialized = 'true';

    const form =
      section.querySelector('#ep-part-type-finder-form');

    const input =
      section.querySelector('#ep-part-type-finder-input');

    const message =
      section.querySelector('#ep-part-type-finder-message');

    const results =
      section.querySelector('#ep-part-type-finder-results');

    if (!form || !input || !message || !results) {
      return;
    }


    const records = Array.from(
      section.querySelectorAll('.ep-part-type-record')
    ).map(function(record) {

      return {
        productTitle: record.dataset.productTitle || '',
        productUrl: record.dataset.productUrl || '',
        modelName: record.dataset.modelName || '',
        primary: record.dataset.primary || '',
        alternates: (record.dataset.alternates || '')
          .split('|||')
          .filter(Boolean),
        aliases: (record.dataset.aliases || '')
          .split('|||')
          .filter(Boolean)
      };

    });


    function normalize(value) {

      return String(value || '')
        .toUpperCase()
        .replace(/[^A-Z0-9]/g,'');

    }


    function searchableValues(record) {

      return [
        record.modelName,
        record.primary,
        ...record.alternates,
        ...record.aliases
      ]
      .map(normalize)
      .filter(Boolean);

    }


    form.addEventListener('submit', function(event) {

      event.preventDefault();

      message.textContent = '';
      results.innerHTML = '';

      const query = normalize(input.value);

      if (!query) {

        message.textContent =
          'Enter a model number or model name.';

        input.focus();
        return;

      }


      let matches = records.filter(function(record) {

        return searchableValues(record).includes(query);

      });


      if (!matches.length) {

        matches = records.filter(function(record) {

          return searchableValues(record).some(function(value) {
            return value.includes(query);
          });

        });

      }


      const uniqueProducts = [];

      matches.forEach(function(match) {

        const alreadyAdded = uniqueProducts.some(function(product) {
          return product.productUrl === match.productUrl;
        });

        if (!alreadyAdded) {
          uniqueProducts.push(match);
        }

      });


      if (!uniqueProducts.length) {

        message.textContent =
          "We couldn't find a compatible part in this category for that model.";

        return;

      }


      message.textContent =
        uniqueProducts.length === 1
          ? 'We found 1 compatible part:'
          : 'We found ' + uniqueProducts.length + ' compatible parts:';


      uniqueProducts.forEach(function(product) {

        const link = document.createElement('a');

        link.href = product.productUrl;
        link.className = 'ep-part-type-result';
        link.textContent = product.productTitle + ' →';

        results.appendChild(link);

      });

    });

  }


  document.addEventListener(
    'DOMContentLoaded',
    initializePartTypeFinder
  );

  document.addEventListener(
    'shopify:section:load',
    initializePartTypeFinder
  );

  initializePartTypeFinder();

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
